(function ($) {

  function setTitle() {
    // if ($('.issues-grid .commentary-column .column-wrapper .eight-col > .title-wrap h6').text() === '') {
    //   $('.issues-grid .commentary-column .column-wrapper .eight-col > .title-wrap').addClass('hidden');
    // }

    // $('.issues-grid .featured-box .column-wrapper').each(function () {
    //   var title = $(this).find('.title:eq(0)').text();
    //   if (title.indexOf(',') > -1) {
    //     var array = title.split(',');
    //     $(this).before('<div class="title-wrap"><h6>' + array[0] + '</h6></div>');
    //   } else {
    //     $(this).before('<div class="title-wrap"><h6>' + title + '</h6></div>');
    //   }


    // })
  }
  $(window).on("load",function(){
    let url = window.location.search;
    url=url.slice(1);
    if(url=="issue-tab-past"){
      $(".issues-grid-filter .filter-wrapper .filter-items li:eq(1)").trigger("click");
    }
  });
  $(document).ready(function () {
    
    setTitle();
    // Filter dropdown
    $('.issues-grid-filter .filter-wrapper .filter-title span').hide();
    const staticWid = $('.issues-grid-filter .filter-data').width() - 60;
    $('.issues-grid-filter .selected-data').hide();
    $('.issues-grid-filter .filter-wrapper .filter-dropdown.date').addClass('hidden');  
    var LiN = $('.issues-grid-filter .filter-wrapper .wrapper .filter-dropdown').length;
    if (LiN > 3) {
      $('.issues-grid-filter .filter-wrapper .wrapper .filter-dropdown', this).eq(2).nextAll().hide().addClass('toggleable');
    }
    $('.issues-grid-filter .filter-wrapper .filter-items').each(function () {
      if ($(this).find('li.selected').length > 0) {
        var text = $(this).find('li.selected').text();
        $(this).parents('.filter-dropdown').find('p').text(text);
        $(this).parent().find('.filter').addClass('used');
      }
    });

    //Closing dropdown by clickling anywhere

    $('.issues-grid-filter .filter-wrapper .filter-items').on("click", function (e) {
      e.stopPropagation();
    });
    $('.issues-grid-filter .filter-wrapper .filter').on('click', function (e) {
      
      e.stopPropagation();
      //e.preventDefault();

      if ($(this).parent().hasClass('open')) {
        var selectedItems = $(".filter-dropdown.open li.selected").length;
        if (selectedItems == 0) {
          $(".filter-dropdown.open .filter p").html("Select from the list...").css("color", "#B9B9B9");
        }
        $(this).parent().removeClass('open');
      }
      else {
        var selectedItems = $(".filter-dropdown.open li.selected").length;
        if (selectedItems == 0) {
          $(".filter-dropdown.open .filter p").html("Select from the list...").css("color", "#B9B9B9");
        }
        $(this).parent().siblings().removeClass('open');
        $(this).parent().addClass('open');
      }
    });
    function urlUpdate(str) {
      var href = window.location.href;
      var href1 = href.split("?");
      var newitem = href1[0].toString();
      href1.shift();
      var newhref = href1.join(" ");
      newhref = newhref.split("$");

      if (href.includes(str)) {
        for (var i = 0; i < newhref.length; i++) {
          if (newhref[i].toString().includes(str)) {
            newhref.splice(i, 1)
            newhref.push(str)
          }
        }
        newhref = newhref.join('$')
        href1 = newitem + '?' + newhref;
        history.pushState({}, null, href1);
      }
      else {
        if (href1.length < 1) {
          history.pushState({}, null, href + '?' + str);
        } else {
          history.pushState({}, null, href + '$' + str);
        }
      }
    }
    function removeUrl() {
      var href = window.location.origin + window.location.pathname;
      history.pushState({}, null, href);
    }
    $('.issues-grid-filter .filter-wrapper .filter-items li').on("click", function (e) {
      
      if ($(this).hasClass('selected')) {  
        $(this).removeClass('selected');
        $(this).parents('.filter-items').removeClass('used');
        

      }
      else {
        $(this).siblings().removeClass('selected');
        $(this).addClass('selected');
        $(this).parent().parent().parent().find('.filter').addClass('used');
        
        if (!$(this).hasClass('date-wrapper')) {
          $(this).parents('.filter-dropdown').removeClass('open');
        }
        
        var text = $(this).text();
        if (text === 'Past Issue') {
          urlUpdate("issue-tab-past");
          $('.issues-grid-filter .filter-wrapper .filter-dropdown.date').removeClass('hidden');
          $('.issues-grid-filter .filter-wrapper .filter-dropdown.date').removeClass('hide');
          $('body').find('.past-issues').removeClass('hidden');
          $('body').find('.current-issues').addClass('hidden');
        } else if (text === 'Current Issue') {
          removeUrl();
          $('.issues-grid-filter .filter-wrapper .filter-dropdown.date').addClass('hidden');
          $('body').find('.current-issues').removeClass('hidden');
          $('body').find('.past-issues').addClass('hidden');
        }

        var selectedItemVal, itemVal, selectedTxt;
        itemVal = $(this).attr("data");
        var itemClass = $(this).attr("class");
        $("#views-exposed-form-issue-past-block-1 .form-item-field-issue-date-value select option").each(function () {
          selectedItemVal = $(this).attr("value");
          selectedTxt = $(this).text();
          if (itemClass === "selected") {
            if (itemVal === selectedItemVal) {
              $(this).attr("selected", "selected");
            }
          }
          else {
            if (itemVal === selectedItemVal) {
              $(this).removeAttr("selected");
            }
          }
        });

        // $(".issues-grid .eight-col .views-exposed-form .form-actions .form-submit").trigger("click");
      }

      if ($(this).parents('.filter-items').find('.selected').length > 0) {
        if ($(this).hasClass('selected')) {
          var text = $(this).text();
          $(this).parents('.filter-dropdown').find('p').text(text);
          $(this).parent().find('.filter').addClass('used');
        }
        var datetext;
        if ($(this).hasClass('date-wrapper')) {
          //date range selection
          var startDate, endDate;
          startDate = $(this).find('.start .selectboxit-text').text() + " " + $(this).find('.start .date input').val() + " " + $(this).find('.start .year input').val();
          endDate = $(this).find('.end .selectboxit-text').text() + " " + $(this).find('.end .date input').val() + " " + $(this).find('.start .year input').val();
          datetext = startDate + " - " + endDate;
          //appending date range
          $(this).parents('.filter-dropdown').find('p').text(datetext);

          var month_number, end_month_number;
          var mounth = $(this).find('.start .selectboxit-text').text();
          var endMounth = $(this).find('.end .selectboxit-text').text()

          var zero, zeroEod, day_zero, day_zeroEod;
          if ($(this).find('.start .date input').val() < 10) {
            day_zero = 0;
          } else {
            day_zero = '';
          }

          if ($(this).find('.end .date input').val() < 10) {
            day_zeroEod = 0;
          } else {
            day_zeroEod = '';
          }

          // Start Date
          if (mounth === "Jan") {
            month_number = 01;
            zero = 0;
          } else if (mounth === "Feb") {
            month_number = 02;
            zero = 0;
          } else if (mounth === "Mar") {
            month_number = 03;
            zero = 0;
          } else if (mounth === "Apr") {
            month_number = 04;
            zero = 0;
          } else if (mounth === "May") {
            month_number = 05;
            zero = 0;
          } else if (mounth === "Jun") {
            month_number = 06;
            zero = 0;
          } else if (mounth === "Jul") {
            month_number = 07;
            zero = 0;
          } else if (mounth === "Aug") {
            month_number = 08;
            zero = 0;
          } else if (mounth === "Sep") {
            month_number = 09;
            zero = 0;
          } else if (mounth === "Oct") {
            month_number = 10;
            zero = '';
          } else if (mounth === "Nov") {
            month_number = 11;
            zero = '';
          } else if (mounth === "Dec") {
            month_number = 12;
            zero = '';
          }

          // End Date
          if (endMounth === "Jan") {
            end_month_number = 01;
            zeroEod = 0;
          } else if (endMounth === "Feb") {
            end_month_number = 02;
            zeroEod = 0;
          } else if (endMounth === "Mar") {
            end_month_number = 03;
            zeroEod = 0;
          } else if (endMounth === "Apr") {
            end_month_number = 04;
            zeroEod = 0;
          } else if (endMounth === "May") {
            end_month_number = 05;
            zeroEod = 0;
          } else if (endMounth === "Jun") {
            end_month_number = 06;
            zeroEod = 0;
          } else if (endMounth === "Jul") {
            end_month_number = 07;
            zeroEod = 0;
          } else if (endMounth === "Aug") {
            end_month_number = 08;
            zeroEod = 0;
          } else if (endMounth === "Sep") {
            end_month_number = 09;
            zeroEod = 0;
          } else if (endMounth === "Oct") {
            end_month_number = 10;
            zeroEod = '';
          } else if (endMounth === "Nov") {
            end_month_number = 11;
            zeroEod = '';
          } else if (endMounth === "Dec") {
            end_month_number = 12;
            zeroEod = '';
          }

          var startDate1 = $(this).find('.start .year input').val() + '-' + day_zero + '' + $(this).find('.start .date input').val() + '-' + zero + '' + month_number;
          var endDate1 = $(this).find('.end .year input').val() + '-' + day_zeroEod + '' + $(this).find('.end .date input').val() + '-' + zeroEod + '' + end_month_number;

          $(".issues-grid .eight-col .views-exposed-form .form-item-field-issue-date-value-1-min input").val(startDate1);
          $(".issues-grid .eight-col .views-exposed-form .form-item-field-issue-date-value-1-max input").val(endDate1);
        }
        $(".issues-grid .eight-col .views-exposed-form .form-actions .form-submit").trigger("click");
      }
      else {
        $(this).parents('.filter').removeClass('used');
        $(this).parents('.filter-dropdown').find('p').text('Select from the list..').css("color", "#B9B9B9");
      }

    });


    if ($('.issues-grid-filter .filter-wrapper .filter-dropdown.date .date-wrap .date-range select').length > 0) {
      $(".issues-grid-filter .filter-wrapper .filter-dropdown.date .date-wrap .date-range select").selectBoxIt({
        showEffect: "fadeIn",
        showEffectSpeed: 200,
        hideEffect: "fadeOut",
        hideEffectSpeed: 200
      });
    }

    //Dropdown Clear functionality
    $('.issues-grid-filter .btn-wrapper a.clear').click(function (e) {
      e.preventDefault();
      $("#views-exposed-form-issue-past-block-1 .form-item-field-issue-date-value select option").each(function () {
        $(this).removeAttr("selected");
      });
      $(".issues-grid .eight-col .views-exposed-form .form-item-field-issue-date-value-1-min input").val(" ");
      $(".issues-grid .eight-col .views-exposed-form .form-item-field-issue-date-value-1-max input").val(" ");

      $(".issues-grid .eight-col .views-exposed-form .form-actions .form-submit").trigger("click");

      $(".filter-dropdown.open .filter p").html("Select from the list...").css("color", "#B9B9B9");
      $(this).parents('.filter-items').find('li.selected').removeClass('selected');
      $(this).parent().parent().parent().find('.filter').removeClass('used');
      //clearing date-range
      if ($(this).parents('.filter-dropdown').hasClass('date') && $(this).parents('.filter-items').find('li.selected').hasClass('date-wrapper')) {
        $(this).parents('.filter-items').find('li.selected.date-wrapper').removeClass('selected');
        $(this).parents('.filter-items').find('li.selected').removeClass('selected');
        $(this).parents('.wrapper').siblings('.selected-data').find('span.range').remove();
      }
      $(this).parents('.filter-items').find('li.selected').each(function () {
        // var li = $(this);
        // var text = li.text();
        $(this).parents(".filter-dropdown").find(".filter p").html("Select from the list...").css("color", "#B9B9B9");
      });
    });

    $(document).on('click', function (e) {
      e.stopPropagation();
      $(".issues-grid-filter .filter-dropdown").removeClass("open");
    });

    $('.issues-detail-block .current-issue-btn span.file').each(function() {
      const link = $(this).find('a');
      const linkText = link.text();
      if (linkText.includes('Download') && linkText.includes('Issue') && linkText.includes('PDF')) {
        link.addClass('btn-white');
        link.attr('target', '_blank');
      }
    });
    let currentDate = new Date();
    let year = currentDate.getFullYear();
    let month = currentDate.getMonth();
    let day = currentDate.getDate();
    let optionAttr = $('.date-wrapper').find('.start .month option').eq(month).attr('value');
    $('.date-wrapper').find('.year input').val(year);
    $('.date-wrapper').find('.date input').val(day);
    $('.date-wrapper').find('.month').val(optionAttr);
  });
})(jQuery);